import { useState, useEffect } from 'react'
import { CheckBox } from 'devextreme-react/check-box';
import { IoCartOutline } from 'react-icons/io5'
import { RxCross2 } from "react-icons/rx";
import { CapitalizeFirstLowercaseRest, ConvertPriceToString } from '../../../Helpers/CustomConverter';
import { useCart } from '../../../Providers/CartProvider';
import useGetProductIndexWithMask from '../../../Components/BasketPage/Hooks/useGetProductIndexWithMask';

const SavedBasketTabTableContent = ({ basket, isCheckedParam, handleDeleteSavedBasketFunc, handleCheckUncheckBasket, setMessageModalFunctionTyp, setShowQuestionAboutReplaceBasket,
    handleMessageModalResult
}) => {
    const [isChecked, setIsChecked] = useState(isCheckedParam)
    const [showBasketItems, setShowBasketItems] = useState(false)
    const { cartItems } = useCart()
    const { getProductIndexWithMask } = useGetProductIndexWithMask()

    const productItemsSection = <tr>
        <td colSpan='9' style={{ padding: 5 }}>
            <div className='table-responsive table-items'  >
                <table className='table table-bordered'>
                    <thead>
                        <tr>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', width: '10%' }}>Indeks</th>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', width: '56%' }}>Nazwa <br /> Cecha</th>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', textAlign: 'right', width: '12%' }}>Cena netto PLN</th>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', textAlign: 'right', width: '5%' }}>Ilość</th>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', width: '3%' }}>Jedn.</th>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', textAlign: 'right', width: '14%' }}>Wartość netto PLN</th>
                        </tr>
                    </thead>
                    <tbody>
                        {basket.basketItems.map((item, key) => (
                            <tr className='hoverable-row' key={key}>
                                <td style={{ alignContent: 'center', verticalAlign: 'middle' }}>{getProductIndexWithMask(item.artNo)}</td>
                                <td style={{ alignContent: 'center', verticalAlign: 'middle' }}>{CapitalizeFirstLowercaseRest(item.product.title)} <br /> {CapitalizeFirstLowercaseRest(item.product.label)}</td>
                                <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>{ConvertPriceToString(item.product.priceNet, null)}</td>
                                <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>{item.qty}</td>
                                <td style={{ alignContent: 'center', verticalAlign: 'middle' }}>{item.product.baseUnit}</td>
                                <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>{ConvertPriceToString(item.totalCost, null)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </td>
    </tr>

    useEffect(() => {
        setIsChecked(isCheckedParam)
    }, [isCheckedParam])

    return (<>
        <tr className="align-middle border-bottom element-pointer" id={basket.basketId} onClick={() => setShowBasketItems(prev => !prev)}>
            <td onClick={(e) => e.stopPropagation()}>
                <CheckBox
                    className="custom-checkbox"
                    value={isChecked}
                    onValueChange={() => {
                        setIsChecked(prev => !prev)
                        handleCheckUncheckBasket(basket, !isChecked)
                    }}
                />
            </td>
            <td>{basket.lp}</td>
            <td>{basket.name}</td>
            <td style={{ textAlign: 'right' }}>{basket.basketItems.length}</td>
            <td style={{ textAlign: 'right' }}>{ConvertPriceToString(basket.netValue, null)}</td>
            <td><IoCartOutline size={25} cursor={'pointer'} color='var(--primary)' onClick={(e) => {
                e.stopPropagation()
                setMessageModalFunctionTyp({ name: 'AddToCart', param: basket.basketId })
                if (cartItems && cartItems.basketItems && cartItems.basketItems.length > 0) {
                    setShowQuestionAboutReplaceBasket(true)
                }
                else {
                    let messageModalFunctionType = { name: 'AddToCart', param: basket.basketId } //przekazujemy, ponieważ setMessageModalFunctionTyp nie zdąrzy zmienic stanu :(
                    handleMessageModalResult('No', messageModalFunctionType)
                }
            }} /></td>
            <td><RxCross2 size={25} cursor={'pointer'} color='var(--error-color)' onClick={(e) => handleDeleteSavedBasketFunc(e, basket.basketId, basket.name)} /></td>
        </tr>
        {showBasketItems &&
            productItemsSection
        }
    </>)
}

export default SavedBasketTabTableContent